import usePaymentButtonInfo from '@apps/www/src/www/hooks/usePaymentButtonInfo';
import SVButton, { SVButtonSIZES, SVButtonUSES } from '@pkgs/shared-client/components/SVButton';
import useStripeCheckout from '@pkgs/shared-client/hooks/useStripeCheckout';
import PaymentButtonType from '@pkgs/shared/enums/PaymentButtonType';

type Props = {
	className?: string;
	id?: string;
	size?: ValueOf<typeof SVButtonSIZES>;
	submitLabel?: string;
} & Parameters<typeof usePaymentButtonInfo>[0];

const SVStripePaymentButtonContainer = ({
	className,
	id,
	size = SVButtonSIZES.WIDE,
	submitLabel = 'Continue with card',
	...otherProps
}: Props) => {
	const { buttonType, type, plan, hasActivePlan } = usePaymentButtonInfo(otherProps);
	const { isLoading, handleStripeCheckout } = useStripeCheckout({
		buttonType,
		type,
		plan,
		hasActivePlan,
	});

	if (buttonType === PaymentButtonType.EDIT_PAYMENT_METHOD) {
		submitLabel = 'Change your payment method';
	} else if (buttonType === PaymentButtonType.SUBSCRIBE && hasActivePlan) {
		submitLabel = 'Change to this plan';
	}

	return (
		<SVButton
			use={
				buttonType === PaymentButtonType.EDIT_PAYMENT_METHOD
					? SVButtonUSES.DEFAULT
					: SVButtonUSES.PRIMARY
			}
			size={size}
			onClick={handleStripeCheckout}
			isLoading={isLoading}
			id={id}
			className={className}
		>
			{submitLabel}
		</SVButton>
	);
};

export default SVStripePaymentButtonContainer;
